import names from './names'

const getMovement = (fig) => {
  if (["Caput Draconis", "Fortuna Major", "Acquisitio", "Tristitia"].includes(names.getNameForFigure(fig))) {
    return "Entering"
  }
  if (["Cauda Draconis", "Amissio", "Fortuna Minor", "Laetitia"].includes(names.getNameForFigure(fig))) {
    return "Exiting"
  }
  if (["Via", "Puer", "Puella", "Carcer"].includes(names.getNameForFigure(fig))) {
    return "Wavering"
  }
  if (["Conjunctio", "Albus", "Rubeus", "Populus"].includes(names.getNameForFigure(fig))) {
    return "Unmoving"
  }
}

const getRulingElement = (fig) => {
  if (["Via", "Puer", "Cauda Draconis", "Fortuna Minor"].includes(names.getNameForFigure(fig))) {
    return "Fire"
  }
  if (["Caput Draconis", "Acquisitio", "Conjunctio", "Rubeus"].includes(names.getNameForFigure(fig))) {
    return "Air"
  }
  if (["Puella", "Carcer", "Amissio", "Laetitia"].includes(names.getNameForFigure(fig))) {
    return "Water"
  }
  if (["Fortuna Major", "Tristitia", "Albus", "Populus"].includes(names.getNameForFigure(fig))) {
    return "Earth"
  }
}

const getSecondaryElement = (fig) => {
  if (["Via", "Caput Draconis", "Puella", "Fortuna Major"].includes(names.getNameForFigure(fig))) {
    return "Fire"
  }
  if (["Puer", "Acquisitio", "Carcer", "Tristitia"].includes(names.getNameForFigure(fig))) {
    return "Air"
  }
  if (["Cauda Draconis", "Conjunctio", "Amissio", "Albus"].includes(names.getNameForFigure(fig))) {
    return "Water"
  }
  if (["Fortuna Minor", "Rubeus", "Laetitia", "Populus"].includes(names.getNameForFigure(fig))) {
    return "Earth"
  }
}

export default {
  sameFigure(fig1, fig2) {
    return fig1.fire === fig2.fire && fig1.air === fig2.air && fig1.water === fig2.water && fig1.earth === fig2.earth
  },

  isSupporting(fig1, fig2) {
    const typesOfSupport = []

    if (getMovement(fig1) === getMovement(fig2)) {
      typesOfSupport.push("Movement")
    }

    if (getRulingElement(fig1) === getRulingElement(fig2)) {
      typesOfSupport.push("Ruling Element")
    }

    if (getSecondaryElement(fig1) === getSecondaryElement(fig2)) {
      typesOfSupport.push("Secondary Element")
    }

    if (typesOfSupport.length > 0) {
      return "Supporting (" + typesOfSupport.join(", ") + ")"
    } else {
      return "Hindering"
    }
  }
}
